/**
 * A labelled hairline rule. Built as a flex row rather than a label floated
 * over an absolutely positioned line, so the label needs no opaque background
 * matching whatever surface the auth card happens to use.
 */
export default function AuthDivider({ label }: { label: string }) {
    return (
        <div className="my-6 flex items-center gap-3">
            <span aria-hidden="true" className="h-px flex-1 bg-hairline" />
            <span className="text-content-muted text-label">{label}</span>
            <span aria-hidden="true" className="h-px flex-1 bg-hairline" />
        </div>
    );
}
